import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Injector, signal } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Entity } from '@jms/model';
import { PickerBaseComponent } from '@jms/ui/ui.pickers.base';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { PickerItemModule } from '@jms/ui/ui.picker.item';
import { EntityItemModule } from '../entity.item';
import { SignalInput } from '@workbuddy/utils/signals';

@Component({
  selector: 'manual-entity-picker',
  templateUrl: './manual.entity.picker.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule,
    EntityItemModule
  ],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: ManualEntityPickerComponent, multi: true }
  ]
})
export class ManualEntityPickerComponent extends PickerBaseComponent {

  @SignalInput() @Input('data') public $data = signal<Entity[]>([]);
  @Input() public placeholder = '<Resource>';

  constructor(
    injector: Injector
  ) {
    super(injector);
  }

}

